import React from 'react';
import { Typography } from '@material-ui/core';

export default function CardDetailTextValue({children}) {
    return (
        <Typography color="textSecondary" variant="body2">{children}</Typography>
    );
}